import { getRelatedTo } from '#component/general/list-filter/helper';

export const getHighlightedSearchResult = filter => {
  const relatedTo = getRelatedTo();
  const searchValue = filter?.[relatedTo]?.search?.value;
  const initialSearchValue = filter?.initial?.[relatedTo]?.search?.value;
  const highlight = (searchValue && filter?.applied) || searchValue === initialSearchValue;

  return highlight ? searchValue : '';
};
